import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Observable} from "rxjs";
import {Monitoramento} from "../../../domain/Monitoramento";

@Injectable()
export class MonitoramentoHttpService  extends AbstractHttpService<Monitoramento>{
    url = '/api/monitoramento';

    findExcel(): Observable<any>{
        return this.http.get<Monitoramento[]>(this.urlBase + encodeURI(`/relatorio`))
    }
}
